import { gql } from '@apollo/client';
import React from 'react';
import { useParams } from 'react-router-dom';
import { ControlLink, Stack } from '@moda/om';
import { hrefFor } from '../../routers/PageRoutes';
import { titleize } from '../../lib/titleize';
import { ProductShopLinksFragment } from '../../generated/types/ProductShopLinksFragment';

import './ProductShopLinks.scss';

export const PRODUCT_SHOP_LINKS_FRAGMENT = gql`
  fragment ProductShopLinksFragment on Variant {
    category
    designerName: designer_name
    designerSlug: designer_slug
    gender
    subcategory
  }
`;

type ProductShopLinksParams = {
  vertical: string;
};

type ProductShopLinksProps = {
  variant: ProductShopLinksFragment;
};

export const ProductShopLinks: React.FC<ProductShopLinksProps> = ({ variant }) => {
  const match = useParams<ProductShopLinksParams>();

  return (
    <Stack className="ProductShopLinks" direction="horizontal" justifyContent="center" space={4}>
      {variant.designerSlug && (
        <ControlLink
          className="ProductShopLinks__link"
          to={hrefFor.DesignerPage({
            designerSlug: variant.designerSlug,
            vertical: match.vertical
          })}
        >
          {`All ${variant.designerName}`}
        </ControlLink>
      )}

      {variant.subcategory.map(
        subcategory =>
          variant?.category[0] &&
          subcategory && (
            <ControlLink
              className="ProductShopLinks__link"
              key={subcategory}
              to={hrefFor.ProductCategoryListingPage({
                category: variant.category[0], // TODO: Always use the first category?
                section: 'shop', // TODO: How to determine section?
                subcategory: subcategory,
                vertical: match.vertical
              })}
            >
              {titleize(`All ${subcategory}`)}
            </ControlLink>
          )
      )}
    </Stack>
  );
};
